import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./AuthContext.jsx";

/**
 * Route guard. Wraps protected children; redirects unauthenticated
 * visitors to /login and remembers where they were trying to go via
 * `state.from` so we can bounce them back after login.
 *
 * While AuthContext is performing its boot-time silent refresh we
 * render a tiny placeholder instead of redirecting — otherwise a hard
 * reload on a protected page would flash /login before the refresh
 * resolves.
 */
export default function RequireAuth({ children }) {
  const { isAuthenticated, bootstrapping } = useAuth();
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
